var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Motor Accident")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Displaying motor accidents reported")])]), _c('div', {
    staticClass: "col-sm-7 hidden-sm-down"
  }, [_c('b-btn', {
    staticClass: "pull-right",
    attrs: {
      "type": "button",
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  }), _vm._v("  Export")])], 1)]), _c('br'), _c('crm-table-appointment')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-423680da","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/CRM/appointment.vue
// module id = 937
// module chunks = 1